import React, { useState, useEffect, useMemo } from 'react';
import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';
import SettingsIcon from '@mui/icons-material/Settings';
import Skeleton from '@material-ui/lab/Skeleton';
import IconButton from '@material-ui/core/IconButton';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';




import api from '../../../../../../services/api';
import NavegadorGestao from "../../../../../../components/NavBarGestao";

import { Button } from "@material-ui/core";
import { ThemeProvider, createTheme } from '@material-ui/core/styles';

//Material UI Imports
import {
    Box,
    Tooltip
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
//Icons Imports
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import {
    MaterialReactTable,

} from 'material-react-table';



function novo() {
    window.location.href = "/gestao/operacional/almoxarifado/insumos/cadastrarinsumo/0/0"

}

const Insumos = () => {


    const [loading, setLoading] = useState(true);

    const [objetos, setObjetos] = useState(null);

    // Dark mode state and theme config
    const [darkMode, setDarkMode] = useState(Cookies.get('darkMode') === 'true');

    useEffect(() => {
        const intervalId = setInterval(() => {
            setDarkMode(Cookies.get('darkMode') === 'true');
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);

    const theme = useMemo(
        () =>
            createTheme({
                palette: {
                    type: darkMode ? 'dark' : 'light',
                    primary: {
                        main: '#3f51b5',
                    },
                    secondary: {
                        main: '#f50057',
                    },
                    background: {
                        default: darkMode ? '#121212' : '#ffffff',
                        paper: darkMode ? '#1e1e1e' : '#ffffff',
                    },
                    text: {
                        primary: darkMode ? '#ffffff' : 'rgba(0, 0, 0, 0.87)',
                        secondary: darkMode ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.54)',
                    },
                },
                overrides: {
                    MuiTextField: {
                        root: {
                            '& .MuiInputBase-input': {
                                color: darkMode ? '#ffffff' : 'inherit',
                            },
                        },
                    },
                    MuiTypography: {
                        root: {
                            color: darkMode ? '#ffffff !important' : 'inherit',
                        },
                    },
                    MuiOutlinedInput: {
                        root: {
                            '& $notchedOutline': {
                                borderColor: darkMode ? 'rgba(255, 255, 255, 0.23)' : 'rgba(0, 0, 0, 0.23)',
                            },
                            '&:hover $notchedOutline': {
                                borderColor: darkMode ? '#ffffff' : 'rgba(0, 0, 0, 0.87)',
                            },
                        },
                    },
                    MuiInput: {
                        underline: {
                            '&:before': {
                                borderBottomColor: darkMode ? 'rgba(255, 255, 255, 0.42)' : 'rgba(0, 0, 0, 0.42)',
                            },
                            '&:hover:not($disabled):before': {
                                borderBottomColor: darkMode ? '#ffffff' : 'rgba(0, 0, 0, 0.87)',
                            },
                        },
                    },
                    MuiInputLabel: {
                        root: {
                            color: darkMode ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.54)',
                        },
                    },
                },
            }),
        [darkMode],
    );
    useEffect(() => {



        async function listar() {

            setLoading(true);

            try {
                const token = Cookies.get('token');

                const headers = {
                    'Authorization': 'Bearer ' + token
                }




                await api.get("v1/protected/almoxarifado/insumos/listar", {
                    headers: headers
                }).then(function (response) {
                    const updatedData = response.data.map(item => {
                        return Object.keys(item).reduce((acc, key) => {
                            acc[key] = item[key] === null ? '' : item[key];
                            return acc;
                        }, {});
                    });


                    setObjetos(updatedData);
                    console.log(" Objetos: " + response);


                    setLoading(false);


                });



            } catch (_err) {

                console.log("Erro ao listar objetos: " + _err)
                setLoading(false);

            }

        }

        listar();


    }, []);

    function handleClickEditar(row) {
        const idInsumo = row.original.id_insumo;
        const url = `/gestao/operacional/almoxarifado/insumos/editarinsumo/${idInsumo}`;
        window.open(url, '_blank');
    }

    function handleClickGerenciar(row) {
        const idInsumo = row.original.id_insumo;
        const url = `/gestao/operacional/almoxarifado/cotacoes/listar/${idInsumo}`;
        window.open(url, '_blank');
    }

    function handleClickReplicar(row) {
        const idInsumo = row.original.id_insumo;
        const url = `/gestao/operacional/almoxarifado/insumos/cadastrarinsumo/${idInsumo}/0`;
        window.open(url, '_blank');
    }

    const columns = useMemo(
        () => [

            {
                accessorKey: 'id_insumo', //normal accessorKey
                header: 'ID Insumo',
                size: 30,
            },


            {
                header: 'Descrição',
                size: 300,
                accessorKey: 'descricao',
                Cell: ({ renderedCellValue }) => (
                    <span >
                        {renderedCellValue}
                    </span>
                ),
            },

            {
                header: 'Tipo',
                accessorKey: 'tipo',
                size: 300,
                Cell: ({ renderedCellValue }) => (
                    <span >
                        {renderedCellValue}
                    </span>
                ),
            },
            {
                accessorKey: 'marca',
                header: 'Marca',
                Cell: ({ renderedCellValue }) => (
                    <span >
                        {renderedCellValue}
                    </span>
                ),
            },




            {
                header: 'Modelo',
                accessorKey: 'modelo',
                size: 200,
                Cell: ({ renderedCellValue }) => (
                    <span >
                        {renderedCellValue}
                    </span>
                ),
            },
            {
                accessorKey: 'serie',
                header: 'Série',
                size: 200,
                Cell: ({ renderedCellValue }) => (
                    <span >
                        {renderedCellValue}
                    </span>
                ),

            },
            {
                accessorKey: 'codigo_interno',
                header: 'Código Interno',
                size: 200,
                Cell: ({ renderedCellValue }) => (
                    <span >
                        {renderedCellValue}
                    </span>
                ),
            },


            {
                accessorKey: 'categoria',
                header: 'Categoria',
                Cell: ({ renderedCellValue }) => (
                    <span >
                        {renderedCellValue}
                    </span>
                ),

            },
            {
                accessorKey: 'versao',
                header: 'Versão',
                size: 200,
                Cell: ({ renderedCellValue }) => (
                    <span >
                        {renderedCellValue}
                    </span>
                ),

            },
            {
                header: 'Data',
                accessorKey: 'data',
                size: 200,
                Cell: ({ renderedCellValue }) => (
                    <span >
                        {renderedCellValue}
                    </span>
                ),
            },

        ],
        [],
    );


    return (
        <ThemeProvider theme={theme}>
            <div style={{ backgroundColor: theme.palette.background.default, minHeight: '100vh', color: theme.palette.text.primary }}>

                <NavegadorGestao
                    Almoxarifado={true}
                    Insumos={true}
                    corFundo={darkMode ? '#333' : 'white'} travado={true} corTexto={darkMode ? 'white' : 'black'}
                />

                <div style={{ padding: 5 }}>
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                        item xs={12}
                    >
                        <Button style={{ margin: 5 }}
                            variant="contained"
                            color="primary"
                            onClick={novo}
                        >
                            Novo Insumo
                        </Button>
                    </Grid>
                    {loading ?
                        <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                        </Skeleton>
                        :

                        <div>
                            <div style={{ backgroundColor: darkMode ? '#1e1e1e' : 'white', margin: 5 }}>
                                {objetos && (
                                    <MaterialReactTable
                                        columns={columns}
                                        data={objetos}
                                        enableBottomToolbar={true}
                                        enableGlobalFilterModes={true}
                                        enablePagination={true}
                                        enableRowActions
                                        enableGlobalFilter={true}
                                        paginationDisplayMode={'pages'}
                                        getRowId={(row) => row.id_insumo}

                                        initialState={{
                                            pagination: { pageSize: 50, pageIndex: 0 }, // Correção da sintaxe aqui
                                            showGlobalFilter: true,
                                        }}
                                        muiTableContainerProps={{ sx: { maxHeight: "1000px" } }}

                                        muiPaginationProps={{
                                            rowsPerPageOptions: [50, 100, 200],
                                            variant: 'outlined',
                                        }}

                                        muiTableBodyRowProps={({ row }) => ({
                                            sx: {
                                                height: 20,
                                                backgroundColor: row.index % 2 === 0 ? (darkMode ? '#2c2c2c' : '#f9f9f9') : (darkMode ? '#1e1e1e' : '#e0e0e0'), // alternância
                                                transition: 'background-color 0.3s',
                                                '&:hover': {
                                                    backgroundColor: darkMode ? '#444' : '#d0f0ff', // hover azul claro
                                                },
                                            },
                                        })}
                                        enableFullScreenToggle={true}
                                        renderDetailPanel={({ row }) => (
                                            <Box
                                                sx={{
                                                    alignItems: 'center',
                                                    display: 'flex',
                                                    justifyContent: 'space-around',
                                                    left: '30px',
                                                    maxWidth: '1000px',
                                                    position: 'sticky',
                                                    width: '100%',
                                                }}
                                            >
                                            </Box>
                                        )}

                                        renderRowActions={({ row }) => (
                                            <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'row', alignItems: 'center' }}>
                                                <Tooltip title="Edit">
                                                    <IconButton onClick={() => handleClickEditar(row)}>
                                                        <EditIcon />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Cotações">
                                                    <IconButton color="error" onClick={() => handleClickGerenciar(row)}>
                                                        <RequestQuoteIcon />
                                                    </IconButton>
                                                </Tooltip>

                                            </Box>
                                        )}
                                    />
                                )}
                            </div>
                        </div>
                    }


                </div>



            </div >
        </ThemeProvider>
    );

};

export default Insumos;